import reducer, { initialState } from '../../reducers/resendCode';
import * as actions from '../../actions/resendCode';

const fn = { reducer, initialState, actions };
export default fn;
 
